import React,  {useState, useEffect} from "react";
import { Link   } from "react-router-dom";
import {
  useHomeNewsQuery
} from '../../data/news-data';
import { formatPostTime, APP_URL } from "../../components/config/Common";
import { useSiteSettings } from '../../contexts/site-settings/site-settings';

import { MdOutlineWatchLater } from "react-icons/md";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const NewsHome = () => {
    //console.log('symbol===', tag)
    const [loading, setLoading] = useState(true);
    const { sitelogo } = useSiteSettings();
    
    const {
        news,
        see_more_link,
        
        error,
    } = useHomeNewsQuery();

    useEffect(() => {
if (news && news.length >= 0) {
setLoading(false);
}
}, [news]);

    //console.log('home news====', news)
    const formatNewsTime = (date) => {
      const now = dayjs();
      const postDate = dayjs(date);
      const diffInDays = now.diff(postDate, "day");
    
      // Show relative time for first 1 days
      if (diffInDays < 1) {
        const diffInMinutes = now.diff(postDate, "minute");
    
        if (diffInMinutes < 1) return "just now";
        if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
    
        const diffInHours = now.diff(postDate, "hour");
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
      }
    
      // After 1 days show full date
      return postDate.format("D MMM YYYY");
    };

    return(
        <>
            {!news ? 
            (<section className="bg-white shadow-md px-5 lg:px-8 py-5"><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                        <div
                        key={i}
                        className="animate-pulse bg-white border border-gray-200 rounded-xl overflow-hidden"
                        >
                            <div className="h-44 bg-slate-200" />
                            <div className="p-4 space-y-3">
                                <div className="h-4 bg-slate-200 rounded w-3/4" />
                                <div className="h-3 bg-slate-200 rounded w-full" />
                                <div className="h-3 bg-slate-200 rounded w-5/6" />
                            </div>
                        </div>
                    ))}
                </div></section>)
            :
            <section className="bg-white shadow-md px-5 lg:px-8 py-5">
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-2xl text-gray-800">Market News</h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {
                    !loading && news?.map((val, index)=>(
                    <div
                        key={index}
                        className="bg-white rounded-xl border border-gray-200 overflow-hidden transition duration-300 group"
                        
                    >
                        {/* Image */}
                        <Link
                        to={val.link}
                        target="_blank"
                        className="block overflow-hidden"
                        >
                            {val.featured_image ? (
                            <img
                            src={val.featured_image}
                            alt={val.alt_text || val.title}
                            className="h-64 w-full object-cover group-hover:scale-105 transition duration-500"
                            />
                            ) : (
                            <img
                            src={process.env.REACT_APP_IMG_URL + sitelogo}
                            alt={val.title}
                            className="h-44 w-full object-contain bg-slate-50 p-6"
                            />
                            )}
                        </Link> 


                        {/* Content */}
                        <div className="p-4 flex flex-col h-full">


                            {/* Title */}
                            <Link to={val.link} title={val.title} target="_blank">
                            <h2
                            className="text-lg leading-snug text-gray-800 group-hover:text-accent transition line-clamp-3"
                            dangerouslySetInnerHTML={{ __html: val.title }}
                            />
                            </Link>


                            {/* Excerpt */}
                            {/* <div
                            className="text-sm text-gray-600 mt-2 line-clamp-3"
                            dangerouslySetInnerHTML={{ __html: val.excerpt }}
                            /> */}


                            {/* Footer */}
                            <div className="pt-4 flex items-center justify-between text-xs text-gray-500">
                                <div className="flex items-center gap-1">
                                <MdOutlineWatchLater size={14} />
                                {formatNewsTime(val.date)}
                                </div>
                                {/* <Link to={val.link} target="_blank">
                                <span className="text-accent font-medium group-hover:underline">
                                Read More →
                                </span>
                                </Link> */}
                            </div>
                        </div>
                    </div>
                    ))
                }
                </div>
                <div className="flex items-center justify-end my-3 text-sm text-accent hover:underline"><Link to={`${APP_URL}${see_more_link}`} target="_blank" className='text-white bg-accent hover:bg-secondary shadow-xs font-medium text-sm px-4 py-2.5 focus:outline-none'>Read More News →</Link></div>
            </section>
            }
            </>
    )

}
export default NewsHome
